// removed by extract-text-webpack-plugin
module.exports = {"theme":"#409eff"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/element-variables.scss
// module id = VUEL
// module chunks = 6